import { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_NEW_DAILY_REPORT_DIALOGUE_ID, ADD_DAILY_REPORT, SET_EDIT_DAILY_REPORT_DIALOGUE_ID } from '../actions/types';
import { DateStringMMDDYYYY } from '../actions/types';
import { format } from 'date-fns';

import PopupWindow from './PopupWindow';

const NewDailyReportDialogue = ({ _newDailyReportDialogueId, _projects, siteboardAction }) => {
  const [beginDate, setBeginDate] = useState(format(new Date().getTime(), 'MM/dd/yyyy'));
  const [beginDateError, setBeginDateError] = useState(null);

  const selectedProject = _projects[_newDailyReportDialogueId];

  const closeDialogue = () => {
    siteboardAction(SET_NEW_DAILY_REPORT_DIALOGUE_ID, {projectId: '00000000-0000-0000-0000-000000000000'});
  };

  const submitDialogue = () => {
    try {
      DateStringMMDDYYYY.validate(beginDate, 'report date');

      const onSuccess = (output) => {
        siteboardAction(SET_EDIT_DAILY_REPORT_DIALOGUE_ID, { dailyReportId: output.dailyReport.id });
        closeDialogue();
      };
      siteboardAction(ADD_DAILY_REPORT, { 
        projectId: _newDailyReportDialogueId, 
        subscriptionId: selectedProject.subscriptionId,
        reportDate: beginDate,
      }, onSuccess);
    } catch(error) {
      setBeginDateError(error.message);
    }
  }

  return (
    <PopupWindow title='New Daily Report' closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
      <div className='max-w-[400px]'>
        {/* filler to make the window expand to its max width */}
        <div className='h-[1px]'>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 
        </div>
        <div className='flex flex-col items-center gap-y-[30px] py-4 text-white'>
          {/* begin date */}
          <div className='flex justify-center gap-x-4'>
            <div className='justify-end'>Report Date</div>
            <div className='flex flex-col justify-center items-center'>
              <div className='w-[150px] font-medium rounded-[12px]'>
                <input 
                  className='w-full h-full px-2 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565] outline-none rounded-[5px] text-center' 
                  type='text' 
                  value={beginDate}
                  onChange={(event) => { setBeginDate(event.target.value); }}
                  onKeyUp={(event) => { if(event.key === 'Enter') { submitDialogue(); } }}
                />
              </div>
              <div className='flex justify-start items-center font-medium text-[0.8em] text-[#a59e9e] ml-[8px]'>mm/dd/year</div>
            </div>
          </div>
          <div className='flex flex-col'>
            {/* create report button  */}
            <div className='flex justify-center'>
              <button  
                className={'bg-[#471cff] hover:bg-[#603aff] text-white py-[7px] px-[42px] font-bold select-none rounded-[10px]' }
                onClick={submitDialogue}
              >
                Create Daily Report
              </button>
            </div>
            {typeof beginDateError === 'string' && 
              <div className='flex justify-center text-[#f12035] font-bold mt-4'>
                <p className='max-w-[300px]'>{beginDateError}</p>
              </div>
            }
          </div>
        </div>
      </div>
    </PopupWindow>
  );
};

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _newDailyReportDialogueId: state.localEphemeral.newDailyReportDialogueId,
  _projects: state.serverSynced.projects,
}};
export default connect(mapStateToProps, { siteboardAction })(NewDailyReportDialogue);
